// src/components/doctor/ReviewStep.jsx
//
// Step 4 — one line per section with a ✓ / ! status and an Edit link back to its
// step, a "Check before signing" row when something needs a second look, what
// signing does, and the Sign button. The button runs the same confirm dialog and
// sign sequence as the header button (useConsultation.askToSign).

import React from 'react';

const ICON = { ok: ['✓', 'Complete'], todo: ['!', 'Needs attention'], warn: ['!', 'Check'], optional: ['–', 'Optional'] };

export default function ReviewStep({
  rows, patientName, canSign, locked = false, signing, saveState, signProblem, confirming, onEdit, onViewContext, onBack, onSign,
}) {
  const name = (patientName || 'the patient').split(' ')[0];
  return (
    <section className="card consult-work" aria-labelledby="consult-step-title">
      <h2 className="consult-work__title" id="consult-step-title" tabIndex={-1}>Review &amp; sign</h2>
      <div className="consult-work__why">Check what will be sent to {name}. Signing can’t be undone.</div>

      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {rows.map(r => {
          const [glyph, word] = ICON[r.status] || ICON.todo;
          return (
            <li key={r.key} className="consult-check" data-testid={`review-${r.key}`}>
              <span className={`consult-check__icon consult-check__icon--${r.status}`} aria-hidden="true">{glyph}</span>
              <div className="consult-check__body">
                <div className="consult-check__title"><span className="sr-only">{word}: </span>{r.title}
                  {r.patientSees && <span className="consult-tag consult-tag--patient">Patient sees</span>}
                </div>
                <div className="consult-check__sum">{r.summary}</div>
              </div>
              {r.key === 'check' && onViewContext && <button type="button" className="consult-link" onClick={onViewContext} aria-label="View open items in the context panel">View</button>}
              {r.step && <button type="button" className="consult-link" onClick={() => onEdit(r.step)} aria-label={`Edit ${r.title}`}>Edit</button>}
            </li>
          );
        })}
      </ul>

      {!locked && (
        <div className="alert alert-success" style={{ marginTop: 12 }}>
          <div className="grow">
            On sign: the visit summary and any prescription are sent to {name}’s app, the appointment is completed and the follow-up item is created.
            Your private notes stay private.
          </div>
        </div>
      )}

      {signProblem && !confirming && (
        <div className="alert alert-error" role="alert" style={{ marginTop: 12 }}><div className="grow">{signProblem}</div></div>
      )}

      <div className="consult-foot">
        <button type="button" className="btn btn-ghost" onClick={onBack}>← Back</button>
        {locked ? <span className="badge badge-active">Signed</span> : (
          <div style={{ textAlign: 'right' }}>
            <button type="button" className="btn btn-accent btn-lg" disabled={!canSign || signing || saveState === 'saving'} onClick={onSign}
              aria-describedby={canSign ? undefined : 'review-sign-hint'}>Sign &amp; complete visit</button>
            {!canSign && <div className="form-hint" id="review-sign-hint" style={{ marginTop: 8 }}>Add a diagnosis to enable signing.</div>}
          </div>
        )}
      </div>
    </section>
  );
}
